// tslint:disable:max-line-length

import React from 'react';

export const ArrowDownSmall = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <polygon points="14,8.7 8,14 2,8.7 2.7,8 7.5,12.3 7.5,2 8.5,2 8.5,12.3 13.3,8" />
    </svg>
  );
};
